// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CE-Xc","rootNoMargin":"styles_rootNoMargin__1u0Bc"};